<template>
  <b-modal
    id="customer-details"
    size="xl"
    :modal-class="['customer-fullscreen-modal']"
    title="Customer Details"
    no-stacking
    no-close-on-backdrop
    scrollable
    @show="onModalShow"
    @hidden="onModalHidden"
  >
    <template #modal-title>
      <div class="d-flex align-items-center">
        <h5 class="text-primary font-weight-normal mb-0 mr-3">
          Customer Details
        </h5>
        <span
          v-if="customerName"
          class="badge badge-light text-dark font-weight-normal"
        >
          {{ customerName }}
        </span>
      </div>
    </template>

    <div class="modal-customer-content" v-if="customerId">
      <!-- Embed the full EditCustomer component -->
      <!-- :key forces re-creation when customerId changes -->
      <EditCustomer :key="customerId" :customerId="customerId" :isModal="true" />
    </div>

    <div v-else class="text-center py-5">
      <i class="fa fa-user-times fa-3x text-muted mb-3"></i>
      <p class="text-muted">No customer selected</p>
    </div>

    <template #modal-footer="{ cancel }">
      <div class="d-flex justify-content-between w-100">
        <div>
          <a
            v-if="customerId"
            :href="getCustomerEditUrl()"
            target="_blank"
            class="btn btn-outline-primary"
          >
            <i class="fa fa-external-link mr-1"></i>
            Open Full Page
          </a>
        </div>
        <b-button variant="secondary" @click="cancel()">Close</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import { GET_CUSTOMER_DETAILS } from "@/store/actions.type.js";

export default {
  name: "CustomerDetailsModel",
  components: {
    EditCustomer: () =>
      import("@/components/admin/customer/EditCustomer/EditCustomer.vue"),
  },
  props: {
    customerid: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      customerId: null,
      customerName: "",
    };
  },
  computed: {
    ...mapGetters(["countryList"]),
  },
  watch: {
    // Watch for customerid prop changes to handle timing issues
    customerid: {
      handler(newVal) {
        if (newVal?.customer_id) {
          this.customerId = newVal.customer_id;
          this.fetchCustomerName();
        }
      },
      immediate: true,
    },
  },
  methods: {
    onModalShow() {
      // Backup: also set on modal show in case watcher hasn't fired yet
      if (this.customerid?.customer_id && !this.customerId) {
        this.customerId = this.customerid.customer_id;
        this.fetchCustomerName();
      }
    },

    onModalHidden() {
      this.customerId = null;
      this.customerName = "";
    },

    async fetchCustomerName() {
      try {
        const response = await this.$store.dispatch(
          GET_CUSTOMER_DETAILS,
          this.customerId
        );
        if (response.status === 200) {
          const details = response.data.details;
          const parts = [details.title, details.fname, details.lname].filter(
            (p) => p && p.trim()
          );
          this.customerName = parts.join(" ");
        }
      } catch (error) {
        console.error("Error fetching customer name:", error);
      }
    },

    getCustomerEditUrl() {
      if (!this.customerId) return "#";
      const encryptedId = this.$CryptoJS.AES.encrypt(
        this.customerId,
        "customer_id"
      ).toString();
      return `/customer/edit/${encodeURIComponent(encryptedId)}`;
    },
  },
};
</script>

<style>
/* Fullscreen-like modal */
.customer-fullscreen-modal .modal-dialog {
  max-width: 95vw !important;
  margin: 1.75rem auto;
}

.customer-fullscreen-modal .modal-content {
  min-height: 90vh;
}

.customer-fullscreen-modal .modal-body {
  max-height: calc(90vh - 120px);
  overflow-y: auto;
  padding: 0;
}

/* Remove extra padding from embedded EditCustomer */
.modal-customer-content .channel-main {
  padding: 1rem;
}

.modal-customer-content .channel-right {
  width: 100%;
}

/* Adjust card margins for modal context */
.modal-customer-content .card {
  margin-bottom: 1rem;
}
</style>
